import React from 'react';
import { NavHashLink } from 'react-router-hash-link';
import useMain from '../../hooks/useMain';
import Image from './../common/image';
import Shadow from './shadow';

const advs = [
	{
		img: 'safe.svg',
		title: 'Safe And Stable',
		content:
			'Your assets are protected with next-generation security protocols and a risk-managed environment you can trust.',
		to: '/advantages#safe',
	},
	{
		img: 'speed.svg',
		title: 'Fast And Efficient',
		content:
			'Experience real-time transactions and 24/7 access to your funds—fast, reliable, and always ready when you are.',
		to: '/advantages#fast',
	},
	{
		img: 'features.svg',
		title: 'Perfect Features',
		content:
			'Unlock a world of innovative tools and financial opportunities designed to shape your perfect investment future.',
		to: '/advantages#features',
	},
	{
		img: 'powerfull.svg',
		title: 'Powerful OS',
		content:
			'Driven by a robust infrastructure, MMP WORLD delivers unmatched performance, scalability, and stability at every step.',
		to: '/advantages#powerfull',
	},
];

function Advantages() {
	const { onHashLinkClick, theme } = useMain();
	return (
		<>
			<div className='advantages'>
				<div className='container pt-5'>
					<div className='row'>
						<div className='col-12'>
							<h1>MMP WORLD Advantages</h1>
						</div>
					</div>
					<div className='row py-2 py-md-5'>
						{advs.map((a, key) => (
							<div
								key={key}
								className='col-xl-3 col-6 mb-5'>
								<div className='adv_cards p-4'>
									<Image
										height={'75px'}
										className={'mb-3'}
										fileName={`home/icons_${theme}/${a.img}`}
									/>
									<h4 className='mb-2 mb-md-5'>{a.title}</h4>
									<p className='d-none d-md-block'>{a.content}</p>

									<NavHashLink
										className={`btn btn-set5-${theme} adv_cards_btn`}
										style={{ borderRadius: '25px' }}
										smooth
										scroll={onHashLinkClick}
										to={a.to}>
										Learn More
									</NavHashLink>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
			<Shadow />
		</>
	);
}

export default Advantages;
